module.exports = __webpack_public_path__ + "img/Jake.89e2c833.png";